var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSingleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1876 15C18.1284 15 18.0716 14.977 18.0299 14.9362L10.1577 7.23382C10.0707 7.14871 9.92931 7.14871 9.84232 7.23382L1.97012 14.9362C1.92835 14.977 1.87161 15 1.81244 15L0.223033 15C0.0249227 15 -0.0744754 14.7667 0.0653563 14.6298L9.84232 5.06384C9.92931 4.97872 10.0707 4.97872 10.1577 5.06384L19.9346 14.6298C20.0745 14.7667 19.9751 15 19.777 15L18.1876 15Z",
    fill: "#FFE500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSingleUp);
export default __webpack_public_path__ + "static/media/arrow-single-up.7fd3a5379f5150458b26d3ef99be1d08.svg";
export { ForwardRef as ReactComponent };